import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Star, Moon, Sparkles, X, ArrowRight, ShieldCheck, Gem, Flame, BookOpen } from 'lucide-react';
export function UpsellBox() {
  const [selectedPlan, setSelectedPlan] = useState<'basic' | 'premium' | null>(null);
  const handlePurchase = (url: string) => {
    window.location.href = url;
  };
  const basicBenefits = ['Liberar emociones acumuladas.', 'Reducir estrés y ansiedad.', 'Rituales de bienestar.', 'Herramientas prácticas.'];
  const premiumBenefits = ['Sanación emocional profunda.', 'Recetario Ancestral.', '8 Bonus del Recetario.', 'Recursos naturales.'];
  const images = {
    basic: 'https://cdn.magicpatterns.com/uploads/5GznuZi4gm3EzqDMppyu24/Kit_Basico.webp',
    premium: 'https://cdn.magicpatterns.com/uploads/9Xn17HHnKGqsXUvQTQnqtV/Kit_premium.webp'
  };
  return <section id="oferta" className="py-16 px-4 relative overflow-hidden bg-[#2C2541] pt-[0px] pb-[0px]" data-id="element-206">
      {/* Floating Decorative Elements */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden opacity-30" data-id="element-207">
        <motion.div animate={{
        y: [0, -10, 0]
      }} transition={{
        duration: 5,
        repeat: Infinity
      }} className="absolute top-10 left-[5%] text-[#D9B15F]/20" data-id="element-208">
          <Moon className="w-12 h-12" data-id="element-209" />
        </motion.div>
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        duration: 7,
        repeat: Infinity
      }} className="absolute top-20 right-[5%] text-[#D9B15F]/20" data-id="element-210">
          <Star className="w-8 h-8" data-id="element-211" />
        </motion.div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10 space-y-[12px]" data-id="element-212">
        <div className="text-center mb-10" data-id="element-213">
          <motion.h2 initial={{
          opacity: 0,
          y: -10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif font-bold text-[#D9B15F] mb-4" data-id="element-214">
            🌙 Antes de continuar...
          </motion.h2>
          <p className="text-lg text-[#B99BE8] max-w-2xl mx-auto" data-id="element-215">
            Elegí el acompañamiento que mejor se adapte a vos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-stretch mb-12" data-id="element-216">
          {/* Kit Básico */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} onClick={() => setSelectedPlan('basic')} className={`flex flex-col bg-[#3A3158]/40 backdrop-blur-md border rounded-[2rem] p-5 md:p-6 transition-all cursor-pointer ${selectedPlan === 'basic' ? 'border-[#D9B15F] bg-[#3A3158]/60' : 'border-[#D9B15F]/10 hover:bg-[#3A3158]/50'}`} data-id="element-217">
            <div className="mb-4" data-id="element-218">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#D9B15F]/10 border border-[#D9B15F]/30 text-[#D9B15F] text-[9px] font-bold tracking-widest mb-3" data-id="element-219">
                ✨ KIT BÁSICO
              </div>
              <h3 className="text-xl font-serif font-bold text-[#F8F5F2] mb-1" data-id="element-220">
                LIBERACIÓN ESENCIAL
              </h3>
              <div className="text-2xl font-bold text-[#D9B15F]" data-id="element-221">$19.990</div>
            </div>

            <div className="relative flex-grow mb-6" data-id="element-222">
              {selectedPlan === 'basic' ? <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1.05
            }} transition={{
              type: 'spring',
              damping: 15
            }} className="rounded-xl overflow-hidden shadow-2xl border border-white/10 -mx-2" data-id="element-223">
                  <img src={images.basic} alt="Kit Básico" className="w-full h-auto object-cover" data-id="element-224" />
                </motion.div> : <div className="space-y-3 py-2" data-id="element-225">
                  <ul className="space-y-1.5 text-xs text-violet-100/70" data-id="element-226">
                    <li className="flex items-start gap-2" data-id="element-227">
                      <CheckCircle2 className="w-3.5 h-3.5 text-violet-500 mt-0.5 shrink-0" data-id="element-228" />
                      <span data-id="element-229">Libro: Kit de Liberación Emocional</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-230">
                      <CheckCircle2 className="w-3.5 h-3.5 text-violet-500 mt-0.5 shrink-0" data-id="element-231" />
                      <span data-id="element-232">4 Bonus Exclusivos</span>
                    </li>
                  </ul>
                  <div className="pt-3 border-t border-white/5" data-id="element-233">
                    <p className="text-[10px] text-violet-300/50 uppercase font-bold tracking-wider mb-2" data-id="element-234">
                      Beneficios:
                    </p>
                    <ul className="grid grid-cols-1 gap-1.5" data-id="element-235">
                      {basicBenefits.slice(0, 2).map((benefit, i) => <li key={i} className="flex items-center gap-2 text-[11px] text-violet-200/80" data-id="element-236">
                          <CheckCircle2 className="w-3 h-3 text-violet-500 shrink-0" data-id="element-237" />
                          {benefit}
                        </li>)}
                    </ul>
                  </div>
                </div>}
            </div>

            <motion.button onClick={() => handlePurchase('https://www.digiital-factory.shop/cart/48513988133113:1')} animate={{
            scale: [1, 1.02, 1],
            boxShadow: ['0 0 0px rgba(217, 177, 95, 0)', '0 0 15px rgba(217, 177, 95, 0.3)', '0 0 0px rgba(217, 177, 95, 0)']
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className={`w-full font-bold py-3.5 rounded-xl text-xs uppercase tracking-wider transition-all ${selectedPlan === 'basic' ? 'bg-[#D9B15F] text-[#2C2541]' : 'bg-[#D9B15F]/20 text-[#D9B15F]/40'}`} data-id="element-238">
              QUIERO EL KIT BÁSICO
            </motion.button>
          </motion.div>

          {/* Kit Premium */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} onClick={() => setSelectedPlan('premium')} className={`flex flex-col backdrop-blur-md border-2 rounded-[2rem] p-5 md:p-6 relative shadow-xl cursor-pointer transition-all ${selectedPlan === 'premium' ? 'border-[#D9B15F] bg-[#3A3158]/80' : 'border-[#D9B15F]/30 bg-gradient-to-b from-[#3A3158]/40 to-[#2C2541]/60'}`} data-id="element-239">
            <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#D9B15F] to-[#B88E44] text-[#2C2541] font-black px-3 py-1 rounded-full text-[8px] tracking-widest shadow-lg flex items-center gap-1 whitespace-nowrap z-10" data-id="element-240">
              <Star className="w-2.5 h-2.5 fill-[#2C2541]" data-id="element-241" />
              MÁS ELEGIDO
            </div>

            <div className="mb-4" data-id="element-242">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#D9B15F]/10 border border-[#D9B15F]/30 text-[#D9B15F] text-[9px] font-bold tracking-widest mb-3" data-id="element-243">
                🌟 KIT PREMIUM
              </div>
              <h3 className="text-xl font-serif font-bold text-[#F8F5F2] mb-1" data-id="element-244">
                TRANSFORMACIÓN INTEGRAL
              </h3>
              <div className="flex items-center gap-2" data-id="element-245">
                <span className="text-xs line-through font-bold text-[#B99BE8]/60" data-id="element-246">
                  $69.990
                </span>
                <span className="text-2xl font-bold text-[#D9B15F]" data-id="element-247">
                  $25.990
                </span>
              </div>
            </div>

            <div className="relative flex-grow mb-6" data-id="element-248">
              {selectedPlan === 'premium' ? <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1.05
            }} transition={{
              type: 'spring',
              damping: 15
            }} className="rounded-xl overflow-hidden shadow-2xl border border-amber-400/30 -mx-2" data-id="element-249">
                  <img src={images.premium} alt="Kit Premium" className="w-full h-auto object-cover" data-id="element-250" />
                </motion.div> : <div className="space-y-3 py-2" data-id="element-251">
                  <div className="p-3 rounded-xl bg-white/5 border border-white/10" data-id="element-252">
                    <ul className="space-y-1.5 text-xs text-violet-100" data-id="element-253">
                      <li className="flex items-start gap-2" data-id="element-254">
                        <CheckCircle2 className="w-3.5 h-3.5 text-amber-400 mt-0.5 shrink-0" data-id="element-255" />
                        <span className="font-bold" data-id="element-256">
                          📖 Recetario Ancestral
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-257">
                        <CheckCircle2 className="w-3.5 h-3.5 text-amber-400 mt-0.5 shrink-0" data-id="element-258" />
                        <span className="font-bold" data-id="element-259">
                          🎁 8 Bonus del Recetario
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="pt-3 border-t border-white/5" data-id="element-260">
                    <ul className="grid grid-cols-1 gap-1.5" data-id="element-261">
                      {premiumBenefits.slice(0, 2).map((benefit, i) => <li key={i} className="flex items-center gap-2 text-[11px] text-violet-100" data-id="element-262">
                          <CheckCircle2 className="w-3 h-3 text-amber-400 shrink-0" data-id="element-263" />
                          {benefit}
                        </li>)}
                    </ul>
                  </div>
                </div>}
            </div>

            <motion.button onClick={() => handlePurchase('https://www.digiital-factory.shop/cart/48513991246073:1')} animate={{
            scale: [1, 1.02, 1],
            boxShadow: ['0 0 0px rgba(217, 177, 95, 0)', '0 0 15px rgba(217, 177, 95, 0.3)', '0 0 0px rgba(217, 177, 95, 0)']
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className={`w-full bg-[#D9B15F] font-black py-3.5 rounded-xl text-xs uppercase tracking-wider transition-all flex items-center justify-center gap-2 ${selectedPlan === 'premium' ? 'text-[#2C2541]' : 'bg-[#D9B15F]/20 text-[#D9B15F]/40'}`} data-id="element-264">
              SÍ, QUIERO EL PACK PREMIUM
              <ArrowRight className="w-3.5 h-3.5" data-id="element-265" />
            </motion.button>
          </motion.div>
        </div>

        {/* Trust Badge - Mercado Líder */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-md mx-auto mb-12 bg-white rounded-2xl overflow-hidden shadow-xl border border-white/10" data-id="element-266">
          <img src="https://cdn.magicpatterns.com/uploads/jPaAeM3unwHJzVsPm2Xesh/mercado_lider.webp" alt="Mercado Líder Platinum - Vendedor Seguro" className="w-full h-auto block" data-id="element-267" />
        </motion.div>

        {/* Comparison Table - Compact */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12 overflow-hidden rounded-2xl border border-[#D9B15F]/10 bg-[#3A3158]/20 text-xs" data-id="element-268">
          <div className="overflow-x-auto" data-id="element-269">
            <table className="w-full text-left border-collapse" data-id="element-270">
              <thead data-id="element-271">
                <tr className="bg-[#3A3158]/40" data-id="element-272">
                  <th className="p-4 text-[#D9B15F] font-bold uppercase tracking-wider" data-id="element-273">
                    Plan
                  </th>
                  <th className="p-4 text-[#D9B15F] font-bold uppercase tracking-wider text-center" data-id="element-274">
                    Básico
                  </th>
                  <th className="p-4 text-[#D9B15F] font-bold uppercase tracking-wider text-center" data-id="element-275">
                    Premium
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[#D9B15F]/5" data-id="element-276">
                <tr data-id="element-277">
                  <td className="p-4 text-[#F8F5F2]" data-id="element-278">Kit Liberación</td>
                  <td className="p-4 text-center" data-id="element-279">
                    <CheckCircle2 className="w-4 h-4 text-[#D9B15F] mx-auto" data-id="element-280" />
                  </td>
                  <td className="p-4 text-center" data-id="element-281">
                    <CheckCircle2 className="w-4 h-4 text-[#D9B15F] mx-auto" data-id="element-282" />
                  </td>
                </tr>
                <tr data-id="element-283">
                  <td className="p-4 text-[#F8F5F2]" data-id="element-284">Recetario + 8 Bonus</td>
                  <td className="p-4 text-center" data-id="element-285">
                    <X className="w-4 h-4 text-[#B99BE8]/20 mx-auto" data-id="element-286" />
                  </td>
                  <td className="p-4 text-center" data-id="element-287">
                    <CheckCircle2 className="w-4 h-4 text-[#D9B15F] mx-auto" data-id="element-288" />
                  </td>
                </tr>
                <tr className="bg-[#D9B15F]/5" data-id="element-289">
                  <td className="p-4 text-[#F8F5F2] font-bold" data-id="element-290">Mejor Valor</td>
                  <td className="p-4 text-center" data-id="element-291">
                    <X className="w-4 h-4 text-[#B99BE8]/20 mx-auto" data-id="element-292" />
                  </td>
                  <td className="p-4 text-center" data-id="element-293">
                    <Star className="w-4 h-4 text-[#D9B15F] fill-[#D9B15F] mx-auto" data-id="element-294" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </motion.div>

        {/* Urgency Section - Compact */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center p-6 rounded-2xl bg-[#3A3158]/40 border border-[#D9B15F]/20 mb-6" data-id="element-295">
          <div className="flex items-center justify-center gap-2 text-[#D9B15F] mb-2" data-id="element-296">
            <Flame className="w-4 h-4 animate-pulse" data-id="element-297" />
            <h4 className="text-sm font-bold uppercase tracking-widest" data-id="element-298">
              ⏳ Oferta única
            </h4>
          </div>
          <p className="text-xs text-[#B99BE8]" data-id="element-299">
            Esta oportunidad no volverá a aparecer.
          </p>
        </motion.div>

        <div className="text-center" data-id="element-300">
          <button className="text-[#B99BE8]/40 hover:text-[#B99BE8]/60 text-[10px] font-medium transition-colors underline underline-offset-4" data-id="element-301">
            No gracias, prefiero continuar sin esta oferta.
          </button>
        </div>
      </div>
    </section>;
}